const STEPS = 6

const layouts = Array.from({ length: STEPS }, (_, i) => ({
  id: `passo-${i + 1}`,
}))

module.exports = layouts
